class Ranger {
	constructor(endpoint1, endpoint2, step) {
		this.max = Math.max(endpoint1, endpoint2);
		this.min = Math.min(endpoint1, endpoint2);
		this.diff = this.max - this.min;
		this.step = step;
	}
	random() {
		return this.normalize(Math.random());
	}
	present(decimal) {
		return this.normalize(decimal * this.diff + this.min);
	}
	normalize(value) {
		value = this.restrict(value);
		if (!this.step) {
			return value;
		}
		return this.min + Math.round((value - this.min) / this.step) * this.step;
	}
	restrict(value) {
		return Math.min(Math.max(value, this.min), this.max);
	}
}

export { Ranger };
//# sourceMappingURL=ranger.js.map
